// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"9303":"css/admin-app.6641","9318":"css/app.6641"}[chunkId] + ".css";
};